/** URL slug for a warehouse team display name (e.g. Bullpen Bisons → bullpen-bisons). */
export function teamSlugFromName(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function teamRouteForName(name: string): string {
  return `/team/${teamSlugFromName(name)}`;
}
